import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const PaymentIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="1.5" y="3.71191" width="15" height="12" rx="4" stroke={props.color} strokeWidth="1.3" />
    <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(1 0 0 -1 12.75 13.4619)" fill={props.color} />
    <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(1 0 0 -1 3.75 7.46191)" fill={props.color} />
    <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(1 0 0 -1 7.5 11.2119)" stroke={props.color} strokeWidth="1.3" />
  </svg>
)
